import { useEffect, useState } from "react";
import { AddOptionsPortal } from "../../Addportal/AddOptionsPortal";
import AddJournalVoucher from "../FormComponents/AddJournalVoucher/AddJournalVoucher";
import AddPaymentAccount from "../FormComponents/AddBankPayment/AddBankPayment";
import AddBankReceipt from "../FormComponents/AddBankReceipt/AddBankReceipt";
import AddCashPayment from "../FormComponents/AddCashPayment/AddCashPayment";
import AddcashReceipt from "../FormComponents/AddCashReciept/AddCashReciept";
import AddContra from "../FormComponents/AddContra/AddContra";
import { SingleVoucher } from "./SingleVoucher";
import "./AddVoucher.scss";
const voucherType = ["Journal Voucher", "Bank Payment", "Bank Receipt", "Cash Payment", "Cash Receipt", "Contra"];
export const AddVoucher = ({ show, onClose, ParentPortalCloseFunction, AddComp, ReferenceFieldName, ReferFormKey }) => {
  const [vouchers, setVoucher] = useState(AddComp.length ? [...AddComp] : [...voucherType]);
  const [toggle, setToggle] = useState(show);
  const [type, setType] = useState("");
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  console.log(AddComp.length, AddComp.length ? [...AddComp] : [...voucherType]);
  useEffect(() => {
    if (searchText !== "") {
      let text = searchText.toLowerCase();
      let filterdData = vouchers.filter((el) => {
        let element = el.toLowerCase();
        return element.includes(text);
      });
      setVoucher(filterdData);
    } else {
      setVoucher(AddComp.length ? [...AddComp] : [...voucherType]);
    }
  }, [searchText]);
  const handleDoubleClick = (el) => {
    console.log(el, "elelelele")
    setOpen(true);
    setType(el);
    onClose();
  };

  useEffect(() => {
    if (show) {
      setToggle(show);
    }
  }, [show]);

  const handleCloseModal = () => {
    setType("");
  };
  console.log(type)
  let modalContent = null;
  if (type === "Journal Voucher") {
    modalContent = (
      <AddJournalVoucher
        ParentPortalCloseFunction={ParentPortalCloseFunction}
        show={open}
        TypeOfPortal="Add"
        submitType="Save"
        onClose={handleCloseModal}
      />
    );
  } else if (type === "Bank Payment") {
    modalContent = (
      <AddPaymentAccount
        ParentPortalCloseFunction={ParentPortalCloseFunction}
        show={open}
        TypeOfPortal="Add"
        submitType="Save"
        onClose={handleCloseModal}
      />
    );
  } else if (type === "Bank Receipt") {
    modalContent = (
      <AddBankReceipt
        ParentPortalCloseFunction={ParentPortalCloseFunction}
        show={open}
        TypeOfPortal="Add"
        submitType="Save"
        onClose={handleCloseModal}
      />
    );
  } else if (type === "Cash Payment") {
    modalContent = (
      <AddCashPayment
        ParentPortalCloseFunction={ParentPortalCloseFunction}
        show={open}
        TypeOfPortal="Add"
        submitType="Save"
        onClose={handleCloseModal}
      />
    );
  } else if (type === "Cash Receipt") {
    modalContent = (
      <AddcashReceipt
        ParentPortalCloseFunction={ParentPortalCloseFunction}
        show={open}
        TypeOfPortal="Add"
        submitType="Save"
        onClose={handleCloseModal}
      />
    );
  } else if (type === "Contra") {
    modalContent = (
      <AddContra
        ParentPortalCloseFunction={ParentPortalCloseFunction}
        show={open}
        TypeOfPortal="Add"
        submitType="Save"
        onClose={handleCloseModal}
      />
    );
  }


  return (
    <>
      <AddOptionsPortal
        onClose={() => {
          onClose();
          setToggle(false);
        }}
        TypeOfPortal="Select Voucher Type"
        open={toggle}
      >
        <div className="loadOptionContainer">
          {/* <input
            value={searchText}
            className="searchInput"
            placeholder="Fast Search(f1)"
            onChange={(e) => setSearchText(e.target.value)}
          /> */}
          <div className="Header">Voucher</div>
          {vouchers?.map((el, i) => (
            <SingleVoucher
              key={i}
              className="child"
              el={el}
              handleDoubleClick={handleDoubleClick}
              ParentPortalCloseFunction={() => {
                setToggle(false)
                ParentPortalCloseFunction()
              }}
              AddComp={AddComp.length ? true : false}
              ReferenceFieldName={ReferenceFieldName}
              ReferFormKey={ReferFormKey}
            />
          ))}
        </div>
      </AddOptionsPortal>
      {open && modalContent}
    </>
  );
};
